export const heart = (() => {
    const placeHolderText = 'Reg rate rhythm'

    return placeHolderText
})